
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/promoteSignUp",
      function () {
        return require("private-next-pages/auth/promoteSignUp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/promoteSignUp"])
      });
    }
  